import {
  MdaClaim,
  MdaDistinctValue,
  MdaValueFilterField,
  MdaValueFilters,
} from "./mda-types";

export const getClaimFilterValue = (
  claim: MdaClaim,
  field: MdaValueFilterField,
): string => claim[field] ?? "";

export const hasActiveValueFilters = (filters: MdaValueFilters): boolean =>
  Object.values(filters).some((excluded) => Boolean(excluded?.length));

/** Pass `ignoreField` to get the rows a column's own filter list should be built from. */
export const applyValueFilters = (
  claims: MdaClaim[],
  filters: MdaValueFilters,
  ignoreField?: MdaValueFilterField,
): MdaClaim[] => {
  const active = (Object.keys(filters) as MdaValueFilterField[])
    .filter((field) => field !== ignoreField && filters[field]?.length)
    .map((field) => ({ field, excluded: new Set(filters[field]) }));

  if (!active.length) {
    return claims;
  }

  return claims.filter((claim) =>
    active.every(
      ({ field, excluded }) => !excluded.has(getClaimFilterValue(claim, field)),
    ),
  );
};

export const getDistinctValues = (
  claims: MdaClaim[],
  field: MdaValueFilterField,
): MdaDistinctValue[] => {
  const counts = new Map<string, number>();
  claims.forEach((claim) => {
    const value = getClaimFilterValue(claim, field);
    counts.set(value, (counts.get(value) ?? 0) + 1);
  });

  return [...counts.entries()]
    .map(([value, count]) => ({ value, count }))
    .sort((a, b) => {
      // Blanks go last, as in Excel.
      if (!a.value) return 1;
      if (!b.value) return -1;
      return a.value.localeCompare(b.value);
    });
};
